<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<th class="col-1">불량원인</th>
							<td class="col-3"><el-input type="textarea" v-model="textarea1" maxlength="100" :rows="10" /></td>
							<th class="col-1">개선대책</th>
							<td class="col-3"><el-input type="textarea" v-model="textarea1" maxlength="100" :rows="10" /></td>
						</tr>
						<tr>
							<th class="col-1">파일첨부</th>
							<td class="col-1">
								<!-- <el-input v-model="input1" /><el-upload class="upload-demo p-0 m-0" :limit="1"
									><span class="unit input-icon"><i class="icon-sf-search" /></span
								></el-upload> -->
							</td>
							<th class="col-1">파일첨부</th>
							<td class="col-1">
								<el-input v-model="input1" /><span class="unit input-icon"><i class="icon-sf-search" /></span>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			data: '',
			input1: '',
			textarea1: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	}
};
</script>

<style></style>
